import React, { createContext, useContext, useRef, useState } from "react";

const ChatContext = createContext(null);

export const ChatProvider = ({ children }) => {
  const focusChatInputRef = useRef(null);
  const blurChatInputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  const focusChatInput = () => {
    if (focusChatInputRef.current) {
      focusChatInputRef.current();
    }
  };

  const blurChatInput = () => {
    if (blurChatInputRef.current) {
      blurChatInputRef.current();
    }
  };

  return (
    <ChatContext.Provider value={{ 
      focusChatInput, 
      blurChatInput,
      focusChatInputRef, 
      blurChatInputRef,
      isFocused,
      setIsFocused
    }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error("useChat must be used within a ChatProvider");
  }
  return context;
};
